import { useEffect } from "react";
import { SITE } from "@/data/site";
import { translatePath } from "@/i18n/paths";
import { useLocation } from "react-router-dom";

const setMeta = (name, content) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setOg = (prop, content) => {
  let el = document.querySelector(`meta[property="${prop}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", prop);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href, hreflang) => {
  const sel = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"][data-seo]`;
  let el = document.querySelector(sel);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (hreflang) el.setAttribute("hreflang", hreflang);
    else el.setAttribute("data-seo", "1");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const Seo = ({ title, description, lang, jsonLd, enOnly }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = title;
    document.documentElement.lang = lang;
    setMeta("description", description);
    setOg("og:title", title);
    setOg("og:description", description);
    setOg("og:type", "website");
    setOg("og:url", SITE.url + pathname);
    setLink("canonical", SITE.url + pathname);
    if (enOnly) {
      document.querySelectorAll('link[rel="alternate"][hreflang]').forEach((l) => l.remove());
    } else {
      const altPath = translatePath(pathname);
      const idHref = SITE.url + (lang === "id" ? pathname : altPath);
      const enHref = SITE.url + (lang === "en" ? pathname : altPath);
      setLink("alternate", idHref, "id");
      setLink("alternate", enHref, "en");
      setLink("alternate", idHref, "x-default");
    }
    // SITE is a module constant; altPath/idHref/enHref are derived inside the effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, lang, pathname, enOnly]);

  useEffect(() => {
    document.querySelectorAll('script[data-jsonld]').forEach((s) => s.remove());
    (jsonLd || []).forEach((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-jsonld", "1");
      s.textContent = JSON.stringify(obj);
      document.head.appendChild(s);
    });
    // obj/s are loop-local variables, not reactive dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jsonLd]);
  return null;
};

export const faqJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map(([q, a]) => ({
    "@type": "Question",
    name: q,
    acceptedAnswer: { "@type": "Answer", text: a },
  })),
});
